import { useContext, useEffect, useState } from 'react'
import Bowser from 'bowser'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
import ToastAnimated from '../../ui-lib/toast'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import ReCAPTCHA from 'react-google-recaptcha'
import { load } from 'recaptcha-v3'
import { Button, IconButton, Icon, Input, InputGroup } from 'rsuite'

import './styles.css'
import logo from '../../assets/logo.png'
import { Context } from '../../context/AuthContext'

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  )
})

function Login() {
  const {
    HandleLogin,
    setEmail,
    setPassword,
    email,
    password,
    setToken2f,
    token2f,
    borderInput,
    setCpVeri,
  } = useContext(Context)
  load('6LdtnFEbAAAAAKHh2TE8emRRPclGjtEUP5edHAD4').then((recaptcha) => {
    recaptcha.execute(setCpVeri(true))
  })
  const [showSenha, setShowSenha] = useState('password')
  const [iconPass, setIconPass] = useState('eye')

  function mostrarSenha() {
    if (showSenha === 'password') {
      setShowSenha('textarea')
      setIconPass('eye-slash')
    } else if (showSenha === 'textarea') {
      setShowSenha('password')
      setIconPass('eye')
    }
  }

  const verificaOs = () => {
    const os = Bowser.parse(window.navigator.userAgent).os.name
    if (os !== 'Windows') {
      localStorage.clear()
    }
  }
  useEffect(() => {
    verificaOs()
  }, [])
  return (
    <div
      className="MainClass"
      style={{
        backgroundColor: ' rgb(242, 244, 248)',
      }}
    >
      <div className="loginInput">
        <Container component={Paper} elevation={15}>
          <form>
            <br />
            <img src={logo} width="350px" />
            <br />
            <label>Email </label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              style={{ borderColor: borderInput }}
              value={email}
              onChange={(event) => {
                setEmail(event.target.value)
              }}
            />
            <InputGroup
              inside
              style={{
                marginBottom: 10,
                marginTop: 10,

                height: '2.5rem',
              }}
              value={password}
              onChange={(event) => {
                setPassword(event.target.value)
              }}
            >
              <Input type={showSenha} placeholder="Senha" />
              <InputGroup.Button>
                <Icon icon={iconPass} onClick={mostrarSenha} />
              </InputGroup.Button>
            </InputGroup>
            <label>GoogleAuth</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Token"
              value={token2f}
              onChange={(event) => {
                setToken2f(event.target.value)
              }}
              onKeyDown={(event) => {
                if (event.key == 'Enter') {
                  HandleLogin(event);
                }
              }}
            />
            <br />
            <ToastAnimated />
            <Button variant="dark" className="btn-block" onClick={HandleLogin}>
              Entrar
            </Button>
          </form>
          <br />
        </Container>
      </div>
    </div>
  )
}

export default Login
